import { Injectable } from '@angular/core';
import {Http, Headers} from '@angular/http';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import { Observable } from 'rxjs/Rx';
import {Service} from "../shared/services/service";
import {Funcoes} from "../funcoes";

@Injectable()
export class FichasService extends Service{

  protected url: string = this.dominio+"/adm/fichas/";

  constructor(protected http: Http, protected func: Funcoes) {
    super();
  }

  ordenaFotos(fotos, id){
    let headers = this.getHeaderLogado();

    return this.http.put(this.url + id+'/ordena-fotos/', JSON.stringify(fotos), {headers})
      .map(res => {
        let json = res.json();
        if(json.Success){
          this.trataSucesso(res);
        }else{
          this.trataErro(json);
        }
        return json;
      });
  }

  apagaFoto(id_ficha, id_foto){

    let headers = this.getHeaderLogado();

    return this.http.delete(this.url + id_ficha+'/fotos/'+id_foto, {headers})
      .map(res => {
        let json = res.json();
        if(json.Success){
          this.trataSucesso(res);
        }else{
          this.trataErro(json);
        }
        return json;
      });
  }

  girarFoto(id_ficha, id_foto){

    let headers = this.getHeaderLogado();

    return this.http.put(this.url + id_ficha+'/fotos/'+id_foto+'/girar', {}, {headers})
      .map(res => {
        let json = res.json();
        if(json.Success){
          this.trataSucesso(res);
        }else{
          this.trataErro(json);
        }
        return json;
      });
  }

  // solicita todas as fotos da ficha em um arquivo zip
  zipFotos(id){
    let headers = this.getHeaderLogado();

    return this.http.get(this.url + id+'/fotos/zip/', {headers})
      .map(res => {
        let json = res.json();
        if(json.Success){
          this.trataSucesso(res);
        }else{
          this.trataErro(json);
        }
        return json;
      });
  }

  // envia a ficha para o cliente por email
  enviarFichaParaCliente(id){
    let headers = this.getHeaderLogado();

    return this.http.post(this.url + id +'/notificar', {},{headers})
      .map(res => {
        let json = res.json();
        if(json.Success){
          this.trataSucesso(res);
        }else{
          this.trataErro(json);
        }
        return json;
      });
  }

  enviarFichaParaEmailEspecifico(id, email) {
    let headers = this.getHeaderLogado();

    return this.http.post(this.url + id + '/notificar-com-email', JSON.stringify({ email }), { headers })
      .map(res => {
        let json = res.json();
        if (json.Success) {
          this.trataSucesso(res);
        } else {
          this.trataErro(json);
        }
        return json;
      });
  }

  setStatus(id_ficha, id_status, notifica = true){

    let headers = this.getHeaderLogado();
    let url = this.dominio + "/adm/fichas/" + id_ficha + "/status/" + id_status + "/";

    if (!notifica) {
      url += "nao-notifica/";
    }

    return this.http
      .put(url, {}, { headers })
      .map(res => {
        let json = res.json();
        if(json.Success){
          this.trataSucesso(res);
        }else{
          this.trataErro(json);
        }
        return json;
      });
  }

  faturarContainer(container){

    let headers = this.getHeaderLogado();

    return this.http
      .put(
        this.dominio+"/adm/faturas/faturar-container/"+container+"/", {},
        { headers }
      )
      .map(res => {
        let json = res.json();
        if(json.Success){
          this.trataSucesso(res);
        }else{
          this.trataErro(json);
        }
        return json;
      });
  }

  getStatus(){
      let headers = this.getHeaderLogado();

      return this.http.get(this.url+'status', {headers})
        .map(res => {
          let json = res.json();
          if(json.Success){
            this.trataSucesso(res);
          }else{
            this.trataErro(json);
          }
          return json;
        });

  }

  apagaFotoTermografo(id_ficha, tg_id?: string, index?: number){
    let headers = this.getHeaderLogado();
    let url = this.url + id_ficha + '/delete-termografo';
    let queryParams = [];
    if (tg_id) {
      queryParams.push('tg_id=' + tg_id);
    }
    if (index) {
      queryParams.push('index=' + index);
    }
    if (queryParams.length > 0) {
      url += '?' + queryParams.join('&');
    }

    return this.http.delete(url, {headers})
      .map(res => {
        let json = res.json();
        if(json.Success){
          this.trataSucesso(res);
        }else{
          this.trataErro(json);
        }
        return json;
      });
  }

  girarFotoTermografo(id_ficha, tg_id?: string, index?: number){
    let headers = this.getHeaderLogado();
    let url = this.url + id_ficha + '/termografo/girar';
    let queryParams = [];
    if (tg_id) {
      queryParams.push('tg_id=' + tg_id);
    }
    if (index) {
      queryParams.push('index=' + index);
    }
    if (queryParams.length > 0) {
      url += '?' + queryParams.join('&');
    }

    return this.http.put(url, {}, {headers})
      .map(res => {
        let json = res.json();
        if(json.Success){
          this.trataSucesso(res);
        }else{
          this.trataErro(json);
        }
        return json;
      });
  }

  importarTermografo(id_ficha, source_ficha_id, source_tg_id, target_tg_id, source_type?: string) {
    let headers = this.getHeaderLogado();
    let body: any = { source_ficha_id, source_tg_id, target_tg_id };
    if (source_type) {
      body.source_type = source_type;
      body.source_id = source_ficha_id;
    }
    return this.http
      .post(
        this.url + id_ficha + '/importar-termografo',
        JSON.stringify(body),
        { headers }
      )
      .map(res => {
        let json = res.json();
        if (json.Success) {
          this.trataSucesso(res);
        } else {
          this.trataErro(json);
        }
        return json;
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/fichas/fichas.service.ts